import { createSelector } from 'reselect';
import { transformPartnerChallenges } from './transformer';

export const challengesState = (state) => state.challenges.challenges || [];
export const participatedChallengesState = (state) =>
    state.challenges.participated || [];

export const challengesLoadingState = (state) =>
    state.challenges.challengesLoading || false;

export const challengeToUpdateState = (state) =>
    state.challenges.challengeToUpdateIndex;

export const getChallenges = createSelector(challengesState, (challenges) =>
    transformPartnerChallenges(challenges),
);

export const getParticipatedChallenges = createSelector(
    participatedChallengesState,
    (challenges) => transformPartnerChallenges(challenges),
);

export const getChallengesLoading = createSelector(
    challengesLoadingState,
    (loading) => loading,
);

export const getChallengeToUpdate = createSelector(
    challengeToUpdateState,
    (index) => index,
);
